import React, { Component } from 'react';
import './App.css';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc, collection, getDocs, onSnapshot } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import Autocompletedrop from './Autocompletedrop';
import firebaseConfig from './firebaseconfig';
import axios from "axios";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Competitions from './Competitions_new';
import StandingsDiv from './views/OverallView';
import OneWeekDiv from './views/OneWeekView';
import BiWeekDiv from './views/BiWeekView';
import RawdataDiv from './views/RawdataView';
import AnalyticsDiv from './views/AnalyticsView'
import Menu from './views/Menu';

// Initialize Firebase with the new modular SDK
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

class AssumeRole extends React.Component {
  state = { weight: '' };
  setweight = (weightvalue) => {
    this.setState({ weight: weightvalue });
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.weight);
    this.setState({ weight: '' });
  };
  render() {
    return (
      <div style={{ width: '100%' }}>
        <form onSubmit={this.handleSubmit}>
          <Autocompletedrop items={this.props.items} setweight={this.setweight} />
        </form>
      </div>
    );
  }
}

const AuthDiv = (props) => {
  const [isSignUp, setIsSignUp] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [displayName, setDisplayName] = React.useState('');
  const [error, setError] = React.useState('');

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      // User signed in successfully
      if (result.user && props.setUser) {
        props.setUser(result.user.displayName);
      }
    } catch (error) {
      console.error("Error signing in with Google:", error);
      setError("Error signing in with Google. Please try again.");
    }
  };

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isSignUp) {
        // Create new account
        if (!displayName.trim()) {
          setError("Please enter your name");
          return;
        }
        const result = await createUserWithEmailAndPassword(auth, email, password);
        // Update the user's display name
        await updateProfile(result.user, {
          displayName: displayName.trim()
        });
        if (props.setUser) {
          props.setUser(displayName.trim());
        }
      } else {
        // Sign in
        const result = await signInWithEmailAndPassword(auth, email, password);
        if (result.user && props.setUser) {
          props.setUser(result.user.displayName || result.user.email);
        }
      }
    } catch (error) {
      console.error("Error with email authentication:", error);
      if (error.code === 'auth/email-already-in-use') {
        setError("This email is already in use. Try signing in instead.");
      } else if (error.code === 'auth/weak-password') {
        setError("Password should be at least 6 characters.");
      } else if (error.code === 'auth/invalid-email') {
        setError("Invalid email address.");
      } else if (error.code === 'auth/user-not-found') {
        setError("No account found with this email. Try signing up instead.");
      } else if (error.code === 'auth/wrong-password') {
        setError("Incorrect password. Please try again.");
      } else {
        setError("Error: " + error.message);
      }
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h1 style={{ marginBottom: '20px', color: '#333' }}>CalorieNinja</h1>
        <p style={{ marginBottom: '30px', color: '#666' }}>
          {isSignUp ? 'Create an account' : 'Sign in to track your weight loss journey'}
        </p>
        
        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleEmailAuth} style={{ marginBottom: '20px' }}>
          {isSignUp && (
            <input
              type="text"
              placeholder="Full Name"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength="6"
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '15px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
          <button
            type="submit"
            style={{
              width: '100%',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              marginBottom: '10px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#45a049'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#4CAF50'}
          >
            {isSignUp ? 'Create Account' : 'Sign In'}
          </button>
        </form>

        <button
          onClick={() => {
            setIsSignUp(!isSignUp);
            setError('');
          }}
          style={{
            width: '100%',
            backgroundColor: 'transparent',
            color: '#4285f4',
            border: 'none',
            padding: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            marginBottom: '20px',
            textDecoration: 'underline'
          }}
        >
          {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
        </button>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          margin: '20px 0',
          color: '#999'
        }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
          <span style={{ padding: '0 10px', fontSize: '14px' }}>OR</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#ddd' }}></div>
        </div>

        <button 
          onClick={handleGoogleSignIn}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            backgroundColor: '#4285f4',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
            margin: '0 auto',
            width: '100%'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#357ae8'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#4285f4'}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path d="M17.6 9.2l-.1-1.8H9v3.4h4.8C13.6 12 13 13 12 13.6v2.2h3a8.8 8.8 0 0 0 2.6-6.6z" fill="#4285F4"/>
              <path d="M9 18c2.4 0 4.5-.8 6-2.2l-3-2.2a5.4 5.4 0 0 1-8-2.9H1V13a9 9 0 0 0 8 5z" fill="#34A853"/>
              <path d="M4 10.7a5.4 5.4 0 0 1 0-3.4V5H1a9 9 0 0 0 0 8l3-2.3z" fill="#FBBC05"/>
              <path d="M9 3.6c1.3 0 2.5.4 3.4 1.3L15 2.3A9 9 0 0 0 1 5l3 2.4a5.4 5.4 0 0 1 5-3.7z" fill="#EA4335"/>
            </g>
          </svg>
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
class App extends Component {
  state = {
    standings: [
      {
        rank: 'Rank', player: 'Player', losstotal: 'Total Loss', lossweek: 'Week Loss', lossbiweek: 'Bi-Week Loss', weekrank: 'Weekly Rank'
        , lastweek: "Thru Week", startingweight: "start", currentweight: "now"
      },
    ],
    rawdata: [
      { week: 'Week', weight: 'Weight' },
    ],
    appuser: null,
    week: 0,
    competition: "",
    compstartdate: new Date(),
    compenddate: new Date(),
    weekentered: false,
    admin: false,
    maxweek: 0,
    players: [],
    competitions: [],
    iconStyle: { textDecoration: 'none', color: 'darkslategrey', fontSize: '39px', margin: '9px' }
  };

  formatLossPercentage = (startingWeight, currentWeight) => {
    const start = Number(startingWeight);
    const current = Number(currentWeight);
    if (!Number.isFinite(start) || !Number.isFinite(current) || start === 0) {
      return "0.00%";
    }

    return (((start - current) / start) * 100).toFixed(2) + "%";
  };

  buildPlayerStatsFromWeeks = (weeks) => {
    const sortedWeeks = weeks
      .map((row) => ({ week: Number(row.week), weight: Number(row.weight) }))
      .filter((row) => Number.isFinite(row.week) && Number.isFinite(row.weight))
      .sort((a, b) => a.week - b.week);

    if (sortedWeeks.length === 0) {
      return null;
    }

    const latestIndex = sortedWeeks.length - 1;
    const latestWeek = sortedWeeks[latestIndex];
    const startingWeek = sortedWeeks[0];
    const lastWeekWeight = latestIndex > 0 ? sortedWeeks[latestIndex - 1].weight : latestWeek.weight;
    const twoWeekWeight = latestIndex > 1 ? sortedWeeks[latestIndex - 2].weight : startingWeek.weight;
    const playerName = (this.state.appuser || '').split(" ")[0];
    const totalLoss = this.formatLossPercentage(startingWeek.weight, latestWeek.weight);

    return {
      twoweekweight: twoWeekWeight,
      lastweekweight: lastWeekWeight,
      currentweight: latestWeek.weight,
      startingweight: startingWeek.weight,
      player: playerName,
      losstotal: totalLoss,
      tablesort: parseFloat(totalLoss),
      lossweek: this.formatLossPercentage(lastWeekWeight, latestWeek.weight),
      lossbiweek: this.formatLossPercentage(twoWeekWeight, latestWeek.weight),
      lastweek: latestWeek.week
    };
  };

  refreshPlayerStatsFromWeeks = () => {
    const weeksCollectionRef = collection(db, "competitions", this.state.competition, "Players", this.state.appuser, "Weeks");
    const docRefPlayer = doc(db, "competitions", this.state.competition, "Players", this.state.appuser);
    return getDocs(weeksCollectionRef).then((querySnapshot) => {
      const weeks = [];
      querySnapshot.forEach((docSnapshot) => {
        weeks.push(docSnapshot.data());
      });

      const playerStats = this.buildPlayerStatsFromWeeks(weeks);
      if (playerStats) {
        return setDoc(docRefPlayer, playerStats);
      }
      return Promise.resolve();
    });
  };

  addNewWeight = (cardInfo) => {
    // cardInfo.forEach(element => {
    //  const maxidrow = this.state.rawdata.reduce((prev, current) => (prev.id > current.id) ? prev : current, 1);
    // const maxweekrow = this.state.rawdata.reduce((prev, current) => (prev.id > current.id) ? prev : current, 1); 
    var token = localStorage.getItem("notification-token");
    axios.get('https://us-central1-calorieninja.cloudfunctions.net/addToTopic?text=' + token + '&comp=' + this.state.competition);

    this.setState(prevState => ({
      rawdata: prevState.rawdata.concat({ week: this.state.week, weight: cardInfo })
    }));
    
    const docRef = doc(db, "competitions", this.state.competition, "Players", this.state.appuser, "Weeks", String(this.state.week));
    setDoc(docRef, { week: this.state.week, weight: cardInfo });
    this.refreshPlayerStatsFromWeeks();
    if (this.state.maxweek > this.state.week) {
      this.setState(prevState => ({ week: prevState.week + 1 }))
    } else { this.setState({ weekentered: true }); }
  };

  editWeightEntry = (week, existingWeight) => {
    const replacementWeight = window.prompt(`Update weight for week ${week}`, existingWeight);
    if (replacementWeight === null) {
      return;
    }

    const normalizedWeight = replacementWeight.trim();
    if (normalizedWeight.length === 0) {
      return;
    }

    const numericWeek = Number(week);
    if (!Number.isFinite(numericWeek)) {
      return;
    }

    this.setState((prevState) => ({
      rawdata: prevState.rawdata.map((row) => {
        if (Number(row.week) === numericWeek) {
          return { ...row, weight: normalizedWeight };
        }
        return row;
      })
    }));

    const docRef = doc(db, "competitions", this.state.competition, "Players", this.state.appuser, "Weeks", String(week));
    setDoc(docRef, { week: numericWeek, weight: normalizedWeight }).then(() => {
      this.refreshPlayerStatsFromWeeks();
    });
  };

  sendNotification = (user, week) => {
    axios.post('https://us-central1-calorieninja.cloudfunctions.net/pushToTopic', {
      "notification": {
        "title": "CalorieNinja",
        "body": user + " added weight for week " + week,
        "click_action": "https://www.calorieninja.com/"
      },
      "to": "/topics/calorie"
    });

  }

  askForPermissionToRecieveNotifications = async () => {
    try {
      const messaging = getMessaging(app);
      
      // Request permission for notifications
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('Notification permission not granted');
        return;
      }

      // VAPID key is optional - you can get it from Firebase Console > Project Settings > Cloud Messaging
      // If not provided, messaging will still work but may have limited functionality
      const vapidKey = process.env.REACT_APP_VAPID_KEY || null;
      const tokenOptions = vapidKey ? { vapidKey } : {};
      
      const token = await getToken(messaging, tokenOptions);
      console.log("token:", token);
      localStorage.setItem("notification-token", token);
      this.setState({ messageToken: token })

      axios.get('https://us-central1-calorieninja.cloudfunctions.net/addToTopic?text=' + token + '&comp=calorie');

      onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
        alert(payload.notification.body);
      });
      
      return token;

    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  }

  assumeUser = (user) => {
    this.setState(prevState => ({
      weekentered: false,
      standings: [
        {
          rank: 'Rank', player: 'Player', losstotal: 'Total Loss', losslbs: 'Lb Loss', lossweek: 'Week Loss', lossbiweek: 'Bi-Week Loss', weekrank: 'Weekly Rank'
          , lastweek: "Thru Week"
        },
      ],
      rawdata: [
        { week: 'Week', weight: 'Weight' },
      ],
      week: 0
    }));
    this.setUser(user);
  };

  setCurrentCompetition = (comp) => {
    this.setState({
      competition: comp.id,
      compstartdate: new Date(comp.startDate),
      compenddate: new Date(comp.endDate)
    }, () => {
      var ONE_WEEK = 1000 * 60 * 60 * 24 * 7;
      var rightnow = new Date();
      var calcweek = Math.floor(((rightnow > this.state.compenddate ? this.state.compenddate : rightnow) - this.state.compstartdate) / ONE_WEEK);

      const weeksCollectionRef = collection(db, "competitions", this.state.competition, "Players", this.state.appuser, "Weeks");
      getDocs(weeksCollectionRef).then((querySnapshot) => {
        const rawdata = [{ week: 'Week', weight: 'Weight' }];
        let latestWeek = -1;

        querySnapshot.forEach((docSnapshot) => {
          const weekData = docSnapshot.data();
          rawdata.push(weekData);

          const weekNumber = Number(weekData.week);
          if (Number.isFinite(weekNumber) && weekNumber > latestWeek) {
            latestWeek = weekNumber;
          };
        });

        this.setState({
          rawdata: rawdata,
          week: latestWeek >= 0 ? latestWeek + 1 : 0,
          weekentered: latestWeek >= 0 && latestWeek >= calcweek,
          maxweek: calcweek
        });
      }); //docref


      const playersCollectionRef = collection(db, "competitions", this.state.competition, "Players");
      onSnapshot(playersCollectionRef, (querySnapshot) => {
        this.setState({
          standings: [
            {
              rank: 'Rank', player: 'Player', losstotal: 'Total Loss', losslbs: 'Lb Loss', lossweek: 'Week Loss', lossbiweek: 'Bi-Week Loss', weekrank: 'Weekly Rank'
              , lastweek: 'Thru Week'
            },
          ],
          players: []
        });
        querySnapshot.forEach((docSnapshot) => {
          // doc.data() is never undefined for query doc snapshots
          this.setState(prevState => ({
            standings: prevState.standings.concat(docSnapshot.data()),
            players: prevState.players.concat({ value: docSnapshot.id })
          }));
          if (docSnapshot.data().week === this.state.week) {
            this.setState({ weekentered: true })
          };
        });
      });
    } //setstate
    );
  };

  addEmptyItem = () => {
    this.setState(prevState => ({
      competitions: prevState.competitions.concat({ id: '0', startDate: '', endDate: '', group: '', description: '', winner: '', runnerup: '' })
    }));
  };

  saveNewCompetition = (props) => {
    // comics: this.state.comics.map(el => (el.id === id ? Object.assign({}, el, { gotIt }) : el))
    const startDate = new Date(props.startDate);
    const month = startDate.toLocaleString('default', { month: 'short' });
    const year = startDate.getFullYear()
    const comp = {
      id: props.group.toLowerCase() + month.toLowerCase() + startDate.getFullYear(),
      description: startDate.toLocaleString('default', { month: 'long' }) + ' ' + year,
      startDate: props.startDate,
      endDate: props.endDate,
      group: props.group,
      winner: props.winner,
      runnerup: props.runnerup
    }

    this.setState(prevState => ({
      competitions: prevState.competitions.filter(x => x.id !== '0').concat(props)
    }));

    const docRef = doc(db, "competitions", comp.id);
    setDoc(docRef, comp);
  };

  setUser = (user) => {

    this.setState({ appuser: user }, () => {
      if (this.state.appuser === "Ian Baker") {
        this.setState({ admin: true });
      }

      const competitionsCollectionRef = collection(db, "competitions");
      onSnapshot(competitionsCollectionRef, async (querySnapshot) => {
        this.setState({
          competitions: []
        });

        // Filter competitions to only show those where user is a participant
        const competitionsPromises = [];
        querySnapshot.forEach((docSnapshot) => {
          competitionsPromises.push(
            (async () => {
              const compData = docSnapshot.data();
              // Check if user is a player in this competition or if user is admin
              const playerDocRef = doc(db, "competitions", compData.id, "Players", this.state.appuser);
              try {
                const playerDoc = await getDoc(playerDocRef);
                if (playerDoc.exists() || this.state.admin) {
                  return compData;
                }
              } catch (error) {
                console.error("Error checking player:", error);
              }
              return null;
            })()
          );
        });

        const competitions = await Promise.all(competitionsPromises);
        const filteredCompetitions = competitions.filter(comp => comp !== null);
        
        this.setState({
          competitions: filteredCompetitions
        });
      });
    });

    if (!localStorage.getItem("notification-token")) {
      this.askForPermissionToRecieveNotifications();
    }
  };
  render() {
    onAuthStateChanged(auth, (user) => {
      if (user && !this.state.appuser) {
        // User is signed in.
        this.setUser(user.displayName);
      } else {
        // User is signed out.
        // ...
      }
    });

    return (
      <div className="App" >

        {!this.state.appuser && <AuthDiv setUser={this.setUser} />}
        {this.state.appuser &&
          <Router>
            <Routes>
              <Route path="/" element={
                <CompetitionsDiv competitions={this.state.competitions}
                  setCurrentCompetition={this.setCurrentCompetition}
                  addEmptyItem={this.addEmptyItem} saveNewCompetition={this.saveNewCompetition} mgn={this.state.admin} />
              } />
              {this.state.competition !== '' && <Route path="/standings/" element={
                <StandingsDiv appuser={this.state.appuser} weekentered={this.state.weekentered} standings={this.state.standings}
                  addNewWeight={this.addNewWeight} week={this.state.week} maxweek={this.state.maxweek} mgn={this.state.admin} iconStyle={this.state.iconStyle} />
              } />}
              {this.state.competition !== '' && <Route path="/oneweek/" element={
                <OneWeekDiv appuser={this.state.appuser} weekentered={this.state.weekentered} standings={this.state.standings}
                  addNewWeight={this.addNewWeight} week={this.state.week} maxweek={this.state.maxweek} mgn={this.state.admin} iconStyle={this.state.iconStyle} />
              } />}
              {this.state.competition !== '' && <Route path="/biweek/" element={
                <BiWeekDiv appuser={this.state.appuser} weekentered={this.state.weekentered} standings={this.state.standings}
                  addNewWeight={this.addNewWeight} week={this.state.week} maxweek={this.state.maxweek} mgn={this.state.admin} iconStyle={this.state.iconStyle} />
              } />}
              {this.state.competition !== '' && <Route path="/rawdata/" element={
                <RawdataDiv rawdata={this.state.rawdata} title={this.state.appuser} mgn={this.state.admin} iconStyle={this.state.iconStyle} onEditWeight={this.editWeightEntry} />
              } />}
              {this.state.competition !== '' && <Route path="/analytics/" element={
                <AnalyticsDiv appuser={this.state.appuser} weekentered={this.state.weekentered} standings={this.state.standings}
                  addNewWeight={this.addNewWeight} week={this.state.week} maxweek={this.state.maxweek} mgn={this.state.admin} iconStyle={this.state.iconStyle} />
              } />}
              <Route path="/admin/" element={
                <AssumeRoleDiv mgn={this.state.admin} assumeUser={this.assumeUser} players={this.state.players} iconStyle={this.state.iconStyle} />
              } />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        }
      </div>
    );
  }
}

const AssumeRoleDiv = (props) => {
  return (
    <div>
      <Menu iconStyle={props.iconStyle} mgn={props.mgn} />
      {props.mgn && <AssumeRole onSubmit={props.assumeUser} items={props.players} />}
    </div>
  )
}



const CompetitionsDiv = (props) => {
  return (
    <div>
      <Competitions competitions={props.competitions} setCurrentCompetition={props.setCurrentCompetition}
        addEmptyItem={props.addEmptyItem} saveNewCompetition={props.saveNewCompetition} mgn={props.mgn}
      />
    </div>
  )
};

export default App;
